import React from "react";
import Card from "../card/Card";
import styles from "./date-card.module.css";

function DateCard({
  title,
  content,
  backgroundColor = "#fff",
  className = "",
}) {
  return (
    <Card
      className={`${styles.dateCard} ${className}`}
      backgroundColor={backgroundColor}
    >
      <p style={{ textTransform: "capitalize" }}>{title}</p>
      <p>{content}</p>
    </Card>
  );
}

export default DateCard;
